import * as _ from 'lodash-es';
import moment from 'moment';
import nonEmpty from './nonEmpty';

type Cutoff = {
  key: string | number;
  label: string | null;
  cutoff?: moment.Moment;
};

const groupByCutoffs = <T extends string, K extends { [key in T]?: Date }>(
  cutoffs: Cutoff[],
  items: K[],
  fieldName: T,
) => {
  const groups = _.groupBy(items, (item) => {
    const { key } = _.find(cutoffs, ({ cutoff }) => {
      return (
        cutoff === undefined || moment(item[fieldName]).isSameOrAfter(cutoff)
      );
    }) ?? { key: undefined };

    return key;
  });

  const groupedCutoffs = cutoffs.map(({ key, label }) => {
    const itemsInGroup = groups[key];

    if (itemsInGroup === undefined) {
      return null;
    }

    return { items: itemsInGroup ?? [], key, label };
  });

  return groupedCutoffs.filter(nonEmpty);
};

export default groupByCutoffs;
